export const ResponseTypes = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

export const CANDIDATE_ORIGIN = {
  NEW_LEAD: "NEW_LEAD",
  SOURCED: "SOURCED",
  REFERRAL: "REFERRAL",
  AGENCY: "AGENCY",
};

export const CANDIDATE_ORIGIN_NAME = {
  NEW_LEAD: "New Leads",
  SOURCED: "Source",
  REFERRAL: "Referral",
  AGENCY: "Agency",
};
